import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Loading from "./utils/loading";
import { DefaultLayout } from "./containers";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { faCheckSquare, faCoffee } from "@fortawesome/free-solid-svg-icons";

library.add(fas, faCheckSquare, faCoffee);

const Login = lazy(() => import("./views/Pages/Login"));
const ResetPassword = lazy(() => import("./views/Pages/Password/reset-password"));
const NewPassword = lazy(() => import("./views/Pages/Password/new-password"));
const Unauthorized = lazy(() => import("./views/Pages/Unauthorized"));
const Page404 = lazy(() => import("./views/Pages/Page404"));
class App extends Component {
  componentDidMount() {
    window.onunhandledrejection = (error) => {
      // Silent crash and Log error
      console.error("UnhandledRejection", error);
    };
    window.onerror = (error) => {
      console.error("Unhandled Error", error);
    };
  }
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
            <Route exact path="/password/reset" name="Init Password Reset" render={(props) => <ResetPassword {...props} />} />
            <Route exact path="/password/new" name="Create new password" render={(props) => <NewPassword {...props} />} />
            <Route exact path="/unauthorized" name="Unauthorized Page" component={(props) => <Unauthorized {...props} />} />
            <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
            <Route path="/" name="Forside" component={(props) => <DefaultLayout {...props} />} />
          </Switch>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
